// extracted by mini-css-extract-plugin
export default {"button":"yj-z","reviewSort":"zj-z"};